import React from 'react';
import { Award } from 'lucide-react';
import '../styles/Experience.css';

const Experience = () => {
  const experiences = [
    {
      id: 'sourcedesk',
      role: 'Digital Marketing Manager / Sr. Paid Media Specialist',
      company: 'Sourcedesk',
      period: 'Feb 2020 – Present',
      description: 'Leading performance marketing and paid media strategy for a premium adaptive footwear brand. Driving customer acquisition and revenue growth through Google Ads, Meta Ads, and omnichannel e-commerce campaigns with advanced attribution modeling and AI-driven optimization.',
      active: true
    },
    {
      id: 'indus-net',
      role: 'Sr. Digital Marketing Executive',
      company: 'Indus Net Technologies',
      period: 'Previous Role',
      description: 'Senior-level execution of digital marketing strategy, performance campaigns, and analytics infrastructure for technology-focused clients.',
      active: false
    },
    {
      id: 'navigators',
      role: 'Digital Marketing Manager',
      company: 'Navigators Software',
      period: 'Previous Role',
      description: 'Full-spectrum digital marketing management, leading paid search and organic growth initiatives, channel strategy, and reporting frameworks.',
      active: false
    }
  ];

  const certifications = [
    { id: 'google-ads', name: 'Google Ads Certified' },
    { id: 'ga-certified', name: 'Google Analytics Certified' },
    { id: 'bing-accredited', name: 'Bing Accredited Professional' },
    { id: 'ai-business', name: 'AI for Business Leaders' },
    { id: 'ai-prompt', name: 'AI Prompt Engineering' }
  ];

  return (
    <section id="experience" className="experience">
      <div className="experience-container">
        <div className="experience-header reveal">
          <div className="section-label">Track Record & Credentials</div>
          <h2 className="section-title">Growth Marketing Consultant Experience & Certifications</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="timeline">
          {experiences.map((exp) => (
            <div key={exp.id} className="timeline-item reveal">
              <div className={`timeline-dot ${exp.active ? 'active' : ''}`}></div>
              <div className="timeline-line"></div>
              <div className="timeline-content">
                <div className="timeline-header">
                  <h3 className="timeline-role">{exp.role}</h3>
                  <span className="timeline-period">{exp.period}</span>
                </div>
                <div className="timeline-company">{exp.company}</div>
                <p className="timeline-description">{exp.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="certifications reveal">
          <div className="cert-header">
            <Award className="cert-icon" size={24} />
            <h3>Certifications</h3>
          </div>
          <div className="cert-grid">
            {certifications.map((cert) => (
              <div key={cert.id} className="cert-badge">
                {cert.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
